/**
 * 说明书生成权限策略
 * @module specification-generation-strategy
 */
import { UsageService } from '@/domains/credit/services/usage-service';
import { BasePermissionStrategy } from '@/domains/shared/strategies/base-permission-strategy';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FeatureKey } from '@telecom/shared/domain/permission';

/**
 * 说明书生成权限策略
 */
@injectable()
export class SpecificationGenerationStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = '说明书:生成';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasPatentSpecificationUsage;
    }
}

@injectable()
export class SpecificationEuGenerationStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = '说明书:生成:EU';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasEuPatentSpecificationUsage;
    }
}

@injectable()
export class SpecificationUsGenerationStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = '说明书:生成:US';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasUsPatentSpecificationUsage;
    }
}

@injectable()
export class SpecificationCnGenerationStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = '说明书:生成:CN';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasCnPatentSpecificationUsage;
    }
}
